import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { zefSetId, zefResetId } from './ngrx-router.action';

@Injectable({ providedIn: 'root' })
export class NgrxRouterService {

  #store = inject(Store<any>);

  setId(key: string, id: string) {
    this.#store.dispatch(zefSetId(key, id));
  }

  resetId(key: string) {
    this.#store.dispatch(zefResetId(key));
  }
}
